import React from "react";
import { Helmet } from "react-helmet";
import { Flex, Box } from "grid-styled";
import { LinkButton } from "./Button";
import { gql } from "apollo-boost";
import { graphql } from "react-apollo";
import UsersList from "./UsersList";
import UsersListPlaceholder from "./UsersListPlaceholder";
import joinPath from "../utils/join-path";

class Users extends React.Component {
  renderUsersList = () => {
    const { match, data: { loading, error, users } } = this.props;

    if (loading) return <UsersListPlaceholder />;
    if (error) return <div>Error</div>;
    return <UsersList users={users} match={match} />;
  };

  render() {
    const { match } = this.props;

    return (
      <Box p={3}>
        <Helmet>
          <title>Users</title>
        </Helmet>
        <Flex pb={2} justify="flex-end">
          <LinkButton variant="primary" to={joinPath(match.url, `/new`)}>
            Add a user
          </LinkButton>
        </Flex>
        {this.renderUsersList()}
      </Box>
    );
  }
}

const USERS_LIST_QUERY = gql`
  query UsersListQuery {
    users {
      id
      name
      email
      role
      deactivated
    }
  }
`;

export default graphql(USERS_LIST_QUERY)(Users);



// WEBPACK FOOTER //
// ./src/components/Users.js